import { getAttributes } from "@tiptap/core";
import { MarkType } from "@tiptap/pm/model";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Editor } from "@tiptap/core";
import { EditorView } from "@tiptap/pm/view";
import Tooltip from "./tippyHelper";
import {isInSingleFloatWindow, isSupportLink} from "@/Utility";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {checkIfAbsolute, isDeepLink} from "@/utils";
import { message } from "antd";
import { t } from "i18next";

// Define type for the ClickHandlerOptions
type ClickHandlerOptions = {
  type: MarkType;
  editor: Editor;
  validate?: (url: string) => boolean;
  modal?: ((options: any) => void | HTMLElement) | null;
};

export default function clickHandler(options: ClickHandlerOptions): Plugin {
  // Create the tooltip instance
  let tooltip = new Tooltip(options);

  // Initialize the tooltip
  let { tippyModal, tippyInstance } = tooltip.init();

  return new Plugin({
    key: new PluginKey("handleClickHyperlink"),
    props: {
      handleClick: (view, pos, event) => {
        if (event.button !== 0) return false;

        // Get the target HTML element and its position
        const nodeTarget: HTMLElement = event.target as HTMLElement;
        const nodePos = view.posAtDOM(nodeTarget, 0);

        // Find the closest link element to the target element
        const link = nodeTarget?.closest("a");
        // if (link){
        //   link.rel = 'noopener noreferrer'
        // }

        // Extract attributes from the state
        const attrs = getAttributes(view.state, options.type.name);

        // Extract href and target attributes from the link element or the state
        let href = link?.href ?? attrs.href;
        const target = link?.target ?? attrs.target;

        // If there is no previewHyperlink modal provided, then open the link in new window
        if (!options.modal) {
          if (link && href) {
            //这个href 会自动带前缀，mac上无法区分是本地文件路径还是www.baidu.com--需要取最原始的属性来处理
            let szText = link.outerHTML;
            let szUrl;
            const nIndex = szText.indexOf('href=');
            if (nIndex > 0){
              const nEnd = szText.indexOf('"',nIndex+6);
              szUrl = szText.substring(nIndex+6,nEnd).replaceAll('&amp;','&');
            }
            // let szUrl =  href.replace("file:///",'').replace(window.location.origin,'')
            if (isInSingleFloatWindow()){
              if (!szUrl?.startsWith('http')) {
                szUrl = 'https://' + szUrl;
              }
              ipcSend('open-url', szUrl)
            }else{
              if (isDeepLink(szUrl)){
                window.handleALink(event,szUrl);
              }else{
                if (checkIfAbsolute(szUrl) || isSupportLink(szUrl)){
                  //本地路径...
                  ipcInvoke('open-url-withwhen',decodeURIComponent(szUrl));
                }else{
                  if (!szUrl?.includes('.')){
                    message.error(t('Invalid link'));
                  }else{
                    if (!szUrl?.startsWith('http')) {
                      szUrl = 'https://' + szUrl;
                    }
                    window.open(szUrl, target);
                  }
                }
              }
            }
          }
          return true;
        }

        // if the link does not contain href attribute, hide the tooltip
        if (!link?.href) return tooltip.hide();

        // Create a preview of the hyperlink
        const hyperlinkPreview = options.modal({
          link,
          nodePos,
          tippy: tooltip,
          ...options,
        });

        // If there is no hyperlink preview, hide the modal
        if (!hyperlinkPreview) return tooltip.hide();

        // Empty the modal and append the hyperlink preview box

        while (tippyModal.firstChild) {
          tippyModal.removeChild(tippyModal.firstChild);
        }

        tippyModal.append(hyperlinkPreview);

        // Update the modal position
        tooltip.update(options.editor.view);

        return false;
      },
    },
  });
}
